module.exports = __webpack_public_path__ + "img/Pot2.82f42a8c.svg";